/* ==========================================================================
   TEA GAMEDAY PIZZA BUILDER - engine
   Companion to sections/tea-gameday-pizza-builder.liquid and
   assets/tea-gameday-builder.css.

   Data contract (rendered by the section as JSON script tags):
     #gdb-config    - numbers + all editable strings
     #gdb-products  - pizzas  [{id, variantId, title, note, type: 'premium'|'base',
                                img, imgHover, extraImgs[], desc, available}]
     #gdb-addons    - addons  [{id, variantId, title, note, price, img, desc, available}]

   Cart contract (identical to tea-dynamic-pizza-builder):
     one master bundle line item with _components / _pack_size / _settings /
     _bundle_id properties + "Item N" display properties; add-ons ride along
     as separate line items; cart attribute Origin = tracking tag.

   Everything lives under window.GDB. Only one builder runs per template.
   ========================================================================== */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('gdb-root');
    if (!root) return;

    var $ = function (id) { return document.getElementById(id); };
    var parseJSON = function (id, fallback) {
      var el = $(id);
      if (!el) return fallback;
      try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
    };

    var config = parseJSON('gdb-config', {});
    var PIZZAS = parseJSON('gdb-products', []);
    var ADDONS = parseJSON('gdb-addons', []);
    var S = config.strings || {};

    var BOX_SIZE = config.boxSize || 6;
    var REQUIRED_PREMIUM = config.requiredPremium || 4;
    var PRICE_BOX = config.boxPrice || 189.99;

    var GDB = window.GDB = {};

    /* ---------- state + helpers ---------- */
    var state = { cart: [], addons: [], unlockedOnce: false, shipShown: false, postAdd: false };
    var wasStartingFull = false;
    var lastUserScroll = 0;
    window.addEventListener('wheel', function () { lastUserScroll = Date.now(); }, { passive: true });
    window.addEventListener('touchmove', function () { lastUserScroll = Date.now(); }, { passive: true });
    window.addEventListener('scroll', function () { lastUserScroll = Date.now(); }, { passive: true });
    var money = function (n) { return '$' + n.toFixed(2); };
    var byId = function (id) { return PIZZAS.filter(function (p) { return p.id === id; })[0]; };
    var addonById = function (id) { return ADDONS.filter(function (a) { return a.id === id; })[0]; };
    var esc = function (str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    };
    var tmpl = function (str, n) { return String(str || '').replace(/%n%/g, n); };

    var premiumCount = function () { return state.cart.filter(function (id) { return byId(id).type === 'premium'; }).length; };
    var baseCount = function () { return state.cart.filter(function (id) { return byId(id).type === 'base'; }).length; };
    var qtyOf = function (id) { return state.cart.filter(function (x) { return x === id; }).length; };
    var addonQty = function (id) { return state.addons.filter(function (x) { return x === id; }).length; };
    var isUnlocked = function () { return premiumCount() >= REQUIRED_PREMIUM; };
    var boxTotal = function () {
      return PRICE_BOX + state.addons.reduce(function (sum, id) { return sum + addonById(id).price; }, 0);
    };

    /* ---------- toast ---------- */
    var toastTimer;
    function toast(msg) {
      var el = $('gdb-toast');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('gdb-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { el.classList.remove('gdb-show'); }, 3200);
    }

    /* ---------- card markup ---------- */
    function soldBadge(p) { return p.available === false ? '<span class="gdb-sold-badge">' + esc(S.soldOut || 'Sold Out') + '</span>' : ''; }

    function specialtyCard(p) {
      var sold = p.available === false;
      return '' +
        '<article class="gdb-pz-card' + (qtyOf(p.id) ? ' gdb-has-qty' : '') + (sold ? ' gdb-sold-out' : '') + '" id="gdb-card-' + p.id + '">' +
          '<div class="gdb-pz-photo"' + (sold ? '' : ' onclick="GDB.add(\'' + p.id + '\')"') + '>' +
            (p.preview ? '<span class="gdb-flag gdb-flag-preview">' + esc(S.previewFlag || 'Preview') + '</span>'
                        : '<span class="gdb-flag">' + esc(S.premiumFlag || 'Limited Time') + '</span>') +
            '<span class="gdb-qty-tag" id="gdb-tag-' + p.id + '">' + qtyOf(p.id) + '×</span>' +
            '<img src="' + p.img + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async">' +
            (p.imgHover ? '<img class="gdb-img-hover" src="' + p.imgHover + '" alt="" aria-hidden="true" loading="lazy" decoding="async">' : '') +
            soldBadge(p) +
          '</div>' +
          '<div class="gdb-pz-body">' +
            '<div class="gdb-pz-info">' +
              '<h3 class="gdb-pz-name">' + esc(p.title) + '</h3>' +
              (p.note ? '<div class="gdb-pz-note">' + esc(p.note) + '</div>' : '') +
              '<button type="button" class="gdb-details-link" onclick="GDB.openDetail(\'' + p.id + '\')">' + esc(S.detailsLabel || 'Details') + '</button>' +
            '</div>' +
            '<div class="gdb-stepper">' +
              '<button type="button" aria-label="Remove one" onclick="GDB.remove(\'' + p.id + '\')">−</button>' +
              '<span class="gdb-val" id="gdb-val-' + p.id + '">' + qtyOf(p.id) + '</span>' +
              '<button type="button" aria-label="Add one" ' + (sold ? 'disabled' : 'onclick="GDB.add(\'' + p.id + '\')"') + '>+</button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }

    function coreCard(p) {
      var sold = p.available === false;
      return '' +
        '<article class="gdb-pz-card gdb-core' + (qtyOf(p.id) ? ' gdb-has-qty' : '') + (sold ? ' gdb-sold-out' : '') + '" id="gdb-card-' + p.id + '">' +
          '<div class="gdb-pz-photo"' + (sold ? '' : ' onclick="GDB.add(\'' + p.id + '\')"') + '>' +
            (p.preview ? '<span class="gdb-flag gdb-flag-preview">' + esc(S.previewFlag || 'Preview') + '</span>'
                        : '<span class="gdb-flag gdb-free">' + esc(S.freeFlag || 'Free') + '</span>') +
            '<span class="gdb-qty-tag" id="gdb-tag-' + p.id + '">' + qtyOf(p.id) + '×</span>' +
            '<img src="' + p.img + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async">' +
            (p.imgHover ? '<img class="gdb-img-hover" src="' + p.imgHover + '" alt="" aria-hidden="true" loading="lazy" decoding="async">' : '') +
            soldBadge(p) +
          '</div>' +
          '<div class="gdb-pz-body" style="padding:10px 12px 12px;flex-wrap:wrap;">' +
            '<div class="gdb-pz-info" style="flex-basis:100%;">' +
              '<h3 class="gdb-pz-name" style="font-size:15px;">' + esc(p.title) + '</h3>' +
              '<div class="gdb-pz-price-chip gdb-free-chip">' + esc(S.freeChip || 'Free in your box') + '</div>' +
            '</div>' +
            '<div class="gdb-stepper" style="margin-top:6px;">' +
              '<button type="button" aria-label="Remove one" onclick="GDB.remove(\'' + p.id + '\')">−</button>' +
              '<span class="gdb-val" id="gdb-val-' + p.id + '">' + qtyOf(p.id) + '</span>' +
              '<button type="button" aria-label="Add one" ' + (sold ? 'disabled' : 'onclick="GDB.add(\'' + p.id + '\')"') + '>+</button>' +
            '</div>' +
            '<button type="button" class="gdb-details-link" style="margin-left:auto;" onclick="GDB.openDetail(\'' + p.id + '\')">' + esc(S.detailsLabel || 'Details') + '</button>' +
          '</div>' +
        '</article>';
    }

    function renderCards() {
      var stack = $('gdb-specialty-stack'), core = $('gdb-core-grid'), tk = $('gdb-ticket-row');
      if (stack) stack.innerHTML = PIZZAS.filter(function (p) { return p.type === 'premium'; }).map(specialtyCard).join('');
      if (core) core.innerHTML = PIZZAS.filter(function (p) { return p.type === 'base'; }).map(coreCard).join('');
      if (tk) tk.innerHTML = ADDONS.map(function (a) {
        var aSold = a.available === false;
        return '<div class="gdb-ticket' + (addonQty(a.id) ? ' gdb-has-qty' : '') + (aSold ? ' gdb-sold-out' : '') + '" id="gdb-ticket-' + a.id + '">' +
          '<img class="gdb-tk-photo" src="' + a.img + '" alt="' + esc(a.title) + '" loading="lazy" onclick="GDB.openAddonDetail(\'' + a.id + '\')">' +
          '<hr class="gdb-tk-sep">' +
          '<div class="gdb-tk-body">' +
            '<div class="gdb-tk-name">' + esc(a.title) + '</div>' +
            (a.note ? '<div class="gdb-tk-desc">' + esc(a.note) + '</div>' : '') +
            '<button type="button" class="gdb-details-link" onclick="GDB.openAddonDetail(\'' + a.id + '\')">' + esc(S.detailsLabel || 'Details') + '</button>' +
            '<div class="gdb-tk-foot">' +
              '<span class="gdb-tk-price">' + money(a.price) + '</span>' +
              '<span class="gdb-tk-ctl" id="gdb-tkctl-' + a.id + '"></span>' +
            '</div>' +
          '</div></div>';
      }).join('');
    }

    /* ---------- cart ops ---------- */
    GDB.add = function (id) {
      if (state.postAdd) return;
      var p = byId(id);
      if (!p || p.available === false) return;
      if (state.cart.length >= BOX_SIZE) { toast(S.boxFull || 'Your box is full. Remove a pizza to swap one in.'); return; }
      if (p.type === 'base') {
        if (!isUnlocked() && !state.unlockedOnce) { toast(S.pickSpecialtyFirst || 'Pick your Starting 4 specialty pies first.'); GDB.pulse('gdb-step1'); return; }
        if (baseCount() >= BOX_SIZE - REQUIRED_PREMIUM) { toast(S.freePicksUsed || 'Both free picks are used. Remove one to swap.'); return; }
      } else {
        if (premiumCount() >= REQUIRED_PREMIUM) { toast(S.specialtyFull || 'Your Starting 4 is set. The last two picks are classics, on the house.'); GDB.pulse('gdb-step2'); return; }
      }
      state.cart.push(id);
      var card = $('gdb-card-' + id);
      if (card) { card.classList.remove('gdb-bump'); void card.offsetWidth; card.classList.add('gdb-bump'); }
      sync(id);
    };

    GDB.remove = function (id) {
      if (state.postAdd) return;
      var i = state.cart.lastIndexOf(id);
      if (i === -1) return;
      state.cart.splice(i, 1);
      sync();
    };

    GDB.removeAt = function (i) {
      if (state.postAdd) return;
      if (state.cart[i] === undefined) return;
      state.cart.splice(i, 1);
      sync();
    };

    GDB.addonChange = function (id, d) {
      if (state.postAdd) return;
      if (d > 0 && (addonById(id) || {}).available === false) return;
      if (d > 0) {
        state.addons.push(id);
        if (addonQty(id) === 1) toast(tmpl(S.addonAdded || '%n% added to your order.', addonById(id).title));
      } else {
        var i = state.addons.lastIndexOf(id);
        if (i !== -1) state.addons.splice(i, 1);
      }
      sync();
    };

    GDB.toggleAddon = function (id) {
      if (addonQty(id) === 0) { GDB.addonChange(id, 1); }
      else { state.addons = state.addons.filter(function (x) { return x !== id; }); sync(); }
    };

    GDB.addAllPremium = function () {
      if (state.postAdd) return;
      var eligible = PIZZAS.filter(function (p) { return p.type === 'premium' && p.available !== false && !p.preview; });
      for (var i = 0; i < eligible.length; i++) {
        if (premiumCount() >= REQUIRED_PREMIUM) break;
        if (qtyOf(eligible[i].id) === 0) state.cart.push(eligible[i].id);
      }
      sync();
    };

    GDB.pulse = function (id) {
      var el = $(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    /* ---------- sync ---------- */
    function sync(addedId) {
      var prem = premiumCount(), total = state.cart.length;

      var s1 = $('gdb-s1-count');
      if (s1) s1.textContent = Math.min(prem, REQUIRED_PREMIUM) + ' of ' + REQUIRED_PREMIUM;
      var need = Math.max(0, REQUIRED_PREMIUM - prem);
      var lc = $('gdb-lock-count');
      if (lc) lc.textContent = tmpl(S.lockCount || '%n% more', need);

      var step2 = $('gdb-step2');
      if (step2 && isUnlocked() && !state.unlockedOnce) {
        state.unlockedOnce = true;
        step2.classList.add('gdb-unlocked');
        setTimeout(function () {
          // yield to the user: no auto-jump while they are actively scrolling,
          // or when the free picks are already on screen
          if (Date.now() - lastUserScroll < 600) return;
          var r = step2.getBoundingClientRect();
          if (r.top >= 0 && r.top < window.innerHeight * 0.6) return;
          step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 380);
      }

      PIZZAS.forEach(function (p) {
        var q = qtyOf(p.id);
        var card = $('gdb-card-' + p.id), val = $('gdb-val-' + p.id), tag = $('gdb-tag-' + p.id);
        if (card) card.classList.toggle('gdb-has-qty', q > 0);
        if (val) val.textContent = q;
        if (tag) tag.textContent = q + '×';
      });

      ADDONS.forEach(function (a) {
        var q = addonQty(a.id);
        var tk = $('gdb-ticket-' + a.id), ctl = $('gdb-tkctl-' + a.id);
        if (tk) tk.classList.toggle('gdb-has-qty', q > 0);
        if (ctl) {
          ctl.innerHTML = a.available === false
            ? '<span class="gdb-tk-soldout">' + esc(S.soldOut || 'Sold Out') + '</span>'
            : q === 0
            ? '<button type="button" class="gdb-tk-add" onclick="GDB.addonChange(\'' + a.id + '\', 1)">' + esc(S.addLabel || 'ADD') + '</button>'
            : '<span class="gdb-tk-stepper">' +
                '<button type="button" aria-label="Remove one" onclick="GDB.addonChange(\'' + a.id + '\', -1)">−</button>' +
                '<span class="gdb-val">' + q + '</span>' +
                '<button type="button" aria-label="Add one" onclick="GDB.addonChange(\'' + a.id + '\', 1)">+</button>' +
              '</span>';
        }
      });

      root.classList.toggle('gdb-post-add', state.postAdd);
      renderSlots(addedId);
      renderDeskSlots();
      var hasItems = state.cart.length + state.addons.length > 0;
      shipJustRevealed = hasItems && !state.shipShown;
      renderReceipt('gdb-receipt-lines');
      renderReceipt('gdb-desk-receipt-lines');
      state.shipShown = hasItems;

      var dupPremium = PIZZAS.some(function (p) { return p.type === 'premium' && qtyOf(p.id) >= 2; });
      var startingFull = premiumCount() >= REQUIRED_PREMIUM;
      ['gdb-addall-d', 'gdb-addall-m'].forEach(function (id) {
        var b = $(id);
        if (!b) return;
        var anyEligible = PIZZAS.some(function (p) { return p.type === 'premium' && p.available !== false && !p.preview; });
        b.style.display = anyEligible ? '' : 'none';
        // invisible whenever "one of each" stops being what the button would do
        b.classList.toggle('gdb-addall-done', startingFull || dupPremium);
      });

      // step 1 completion state: gold first-down line + turf marker while the
      // Starting 4 is set, plus a one-time slot pulse in the scoreboard bar
      var step1 = $('gdb-step1');
      if (step1) step1.classList.toggle('gdb-step1-complete', startingFull);
      if (startingFull && !wasStartingFull) {
        ['gdb-slot-track', 'gdb-desk-slots'].forEach(function (id) {
          var el = $(id);
          if (!el) return;
          el.classList.remove('gdb-slots-cheer');
          void el.offsetWidth;
          el.classList.add('gdb-slots-cheer');
          setTimeout(function () { el.classList.remove('gdb-slots-cheer'); }, 1000);
        });
      }
      wasStartingFull = startingFull;

      var sbLabel = $('gdb-sb-label');
      if (sbLabel) {
        if (state.postAdd) {
          sbLabel.textContent = '✓ ' + (S.postAddNote || 'Box added to cart');
          sbLabel.classList.add('gdb-sb-added');
        } else {
          sbLabel.textContent = (S.boxLabel || 'Your Box') + ' · ' + total + ' of ' + BOX_SIZE;
          sbLabel.classList.remove('gdb-sb-added');
        }
      }
      var sbTotal = $('gdb-sb-total');
      if (sbTotal) sbTotal.textContent = money(total === 0 ? 0 : boxTotal());

      updateCTA();
    }

    function updateCTA() {
      var prem = premiumCount(), total = state.cart.length;
      var ready = total === BOX_SIZE && prem >= REQUIRED_PREMIUM;
      var need = Math.max(0, REQUIRED_PREMIUM - prem);
      var label, cls = 'gdb-sb-cta';

      if (state.postAdd) {
        label = S.ctaAgain || 'Build Another Box';
        cls += ' gdb-armed';
      } else if (ready) {
        label = (S.ctaReady || 'Add Box to Cart') + ' · ' + money(boxTotal());
        cls += ' gdb-armed gdb-glimmer';
      } else if (!isUnlocked()) {
        label = need === REQUIRED_PREMIUM ? tmpl(S.ctaStart || 'Pick %n% Specialty Pizzas', REQUIRED_PREMIUM)
                                          : tmpl(S.ctaMoreSpecialty || 'Pick %n% More Specialty', need);
      } else {
        var left = BOX_SIZE - total;
        label = left === 1 ? (S.ctaFreePickOne || 'Call 1 Free Pick') : tmpl(S.ctaFreePicks || 'Call %n% Free Picks', left);
        cls += ' gdb-armed-free';
      }
      ['gdb-sb-cta', 'gdb-desk-cta'].forEach(function (id) {
        var b = $(id);
        if (!b) return;
        b.textContent = label;
        b.className = cls;
        b.disabled = false;
      });
    }

    /* ---------- slots ---------- */
    function renderSlots(addedId) {
      var el = $('gdb-slot-track');
      if (!el) return;
      var html = '';
      for (var i = 0; i < BOX_SIZE; i++) {
        var pid = state.cart[i];
        if (pid) {
          var justAdded = addedId && i === state.cart.length - 1 && pid === addedId;
          html += '<span class="gdb-slot gdb-filled' + (justAdded ? ' gdb-pop' : '') + '"><img src="' + (byId(pid).imgThumb || byId(pid).img) + '" alt="" decoding="async"></span>';
        } else {
          html += '<span class="gdb-slot' + (i >= REQUIRED_PREMIUM ? ' gdb-free-slot' : '') + '"></span>';
        }
      }
      el.innerHTML = html;
    }

    function renderDeskSlots() {
      var el = $('gdb-desk-slots');
      if (!el) return;
      var html = '';
      for (var i = 0; i < BOX_SIZE; i++) {
        var pid = state.cart[i];
        var isFree = i >= REQUIRED_PREMIUM;
        if (pid) {
          html += '<button type="button" class="gdb-dslot gdb-filled' + (isFree ? ' gdb-free-slot' : '') + '" onclick="GDB.removeAt(' + i + ')" aria-label="Remove ' + esc(byId(pid).title) + '">' +
            '<img src="' + (byId(pid).imgThumb || byId(pid).img) + '" alt="" decoding="async">' +
            '<span class="gdb-ds-x"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke-width="2.6" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
            '<span class="gdb-ds-x-name">' + esc(byId(pid).title) + '</span></span>' +
          '</button>';
        } else {
          html += '<button type="button" class="gdb-dslot' + (isFree ? ' gdb-free-slot' : '') + '" onclick="GDB.pulse(\'' + (isFree ? 'gdb-step2' : 'gdb-step1') + '\')" aria-label="' + (isFree ? 'Add a free pick' : 'Add a specialty pizza') + '">' +
            '<span class="gdb-ds-empty"><span class="gdb-ds-ph"></span><span class="gdb-ds-label">' + esc(isFree ? (S.slotFree || 'Free Pick') : (S.slotSpecialty || 'Specialty')) + '</span></span>' +
          '</button>';
        }
      }
      el.innerHTML = html;
    }

    /* ---------- receipt ---------- */
    var shipJustRevealed = false;
    function renderReceipt(containerId) {
      var el = $(containerId);
      if (!el) return;
      var isDesk = containerId === 'gdb-desk-receipt-lines';
      var xSvg = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
      var pizzaX = function (id, hover) {
        return '<button type="button" class="gdb-rc-x' + (hover ? ' gdb-rc-x-hover' : '') + '" onclick="GDB.remove(\'' + id + '\')" aria-label="Remove one">' + xSvg + '</button>';
      };
      var dashOrX = function (id) {
        // desktop: hyphen at rest, becomes the remove X when the line is hovered
        return '<span class="gdb-rc-dash">-</span><button type="button" class="gdb-rc-x gdb-rc-x-swap" onclick="GDB.remove(\'' + id + '\')" aria-label="Remove one">' + xSvg + '</button>';
      };
      var addonX = function (id) {
        return '<button type="button" class="gdb-rc-x' + (isDesk ? ' gdb-rc-x-hover' : '') + '" onclick="GDB.addonChange(\'' + id + '\', -1)" aria-label="Remove one">' + xSvg + '</button>';
      };
      if (state.cart.length === 0 && state.addons.length === 0) {
        el.innerHTML = '<div class="gdb-rc-empty">' + esc(S.emptyCart || 'Your box is empty. Pick your Starting 4 to begin.') + '</div>';
        return;
      }
      var tally = function (arr) { return arr.reduce(function (t, id) { t[id] = (t[id] || 0) + 1; return t; }, {}); };
      var html = '';
      if (state.postAdd) {
        html += '<div class="gdb-added-note"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' + esc(S.postAddNote || 'Box added to cart') + '</div>';
      }

      html += '<div class="gdb-rc-block-label">' + esc(S.startingLabel || 'Starting 4') + ' · ' + money(PRICE_BOX) + '</div>';
      var premIds = state.cart.filter(function (id) { return byId(id).type === 'premium'; });
      var starting = tally(premIds.slice(0, REQUIRED_PREMIUM));
      if (Object.keys(starting).length === 0) html += '<div class="gdb-rc-empty" style="padding:8px 0;">' + esc(S.noSpecialtyYet || 'No specialty pies picked yet') + '</div>';
      Object.keys(starting).forEach(function (id) {
        html += '<div class="gdb-rc-line"><span class="gdb-nm"><span class="gdb-q">' + starting[id] + '×</span>' + esc(byId(id).title) + '</span><span class="gdb-pr">' + (isDesk ? dashOrX(id) : pizzaX(id)) + '</span></div>';
      });

      var baseIds = state.cart.filter(function (id) { return byId(id).type === 'base'; });
      if (baseIds.length) {
        html += '<div class="gdb-rc-block-label">' + esc(S.freeLabel || 'Free Picks') + '</div>';
        var bt = tally(baseIds);
        Object.keys(bt).forEach(function (id) {
          html += '<div class="gdb-rc-line"><span class="gdb-nm"><span class="gdb-q">' + bt[id] + '×</span>' + esc(byId(id).title) + '</span><span class="gdb-pr"><span class="gdb-free-tag">' + esc(S.freeTag || 'FREE') + '</span>' + pizzaX(id, isDesk) + '</span></div>';
        });
      }

      if (state.addons.length) {
        html += '<div class="gdb-rc-block-label">' + esc(S.addonLabel || 'Extra Points') + '</div>';
        var at = tally(state.addons);
        Object.keys(at).forEach(function (id) {
          var a = addonById(id);
          html += '<div class="gdb-rc-line gdb-rc-line-addon"><span class="gdb-nm"><span class="gdb-q">' + at[id] + '×</span>' + esc(a.title) + '</span><span class="gdb-pr">+' + money(a.price * at[id]) + addonX(id) + '</span></div>';
        });
      }

      html += '<div class="gdb-ship-block' + (shipJustRevealed ? ' gdb-ship-reveal' : '') + '">' +
                '<div class="gdb-rc-ship"><span>' + esc(S.shipRow1 || 'Shipping & handling') + '</span><span class="gdb-free-val">' + esc(S.includedText || 'INCLUDED') + '</span></div>' +
                '<div class="gdb-rc-ship"><span>» ' + esc(S.shipRow2 || 'Dry ice + insulated cooler') + '</span><span class="gdb-free-val">' + esc(S.includedText || 'INCLUDED') + '</span></div>' +
              '</div>' +
              '<div class="gdb-rc-total"><span>' + esc(S.totalLabel || 'Total') + '</span><span>' + money(state.cart.length ? boxTotal() : 0) + '</span></div>';
      el.innerHTML = html;
    }

    /* ---------- body scroll lock (iOS-proof position-fixed technique) ---------- */
    var scrollLocked = false;
    function updateScrollLock() {
      var anyOpen = document.querySelector('.gdb-sheet.gdb-open, .gdb-modal-veil.gdb-open');
      // Overflow-based freeze: scrollY never changes, so the theme's
      // hide-on-scroll header is never signalled and cannot slide in.
      if (anyOpen && !scrollLocked) {
        scrollLocked = true;
        document.documentElement.classList.add('gdb-scroll-lock');
      } else if (!anyOpen && scrollLocked) {
        scrollLocked = false;
        document.documentElement.classList.remove('gdb-scroll-lock');
      }
    }

    /* ---------- drag-to-dismiss on the grab handle ---------- */
    function bindSheetDrag(sheet) {
      var zone = sheet.querySelector('.gdb-grab-zone');
      if (!zone) return;
      var dragging = false, startY = 0, curY = 0, startT = 0;
      zone.addEventListener('touchstart', function (e) {
        dragging = true;
        startY = e.touches[0].clientY;
        curY = 0; startT = Date.now();
        sheet.style.transition = 'none';
      }, { passive: true });
      window.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        curY = Math.max(0, e.touches[0].clientY - startY);
        sheet.style.transform = 'translateY(' + curY + 'px)';
      }, { passive: true });
      window.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        sheet.style.transition = '';
        var flick = curY > 40 && (Date.now() - startT) < 250;
        sheet.style.transform = '';
        if (curY > 110 || flick) GDB.closeAllSheets();
      });
    }
    bindSheetDrag($('gdb-receipt-sheet') || document.createElement('div'));
    bindSheetDrag($('gdb-detail-sheet') || document.createElement('div'));

    /* ---------- sheets, detail, gallery ---------- */
    function openSheet(id) {
      var el = $(id), veil = $('gdb-sheet-veil');
      if (el) el.classList.add('gdb-open');
      if (veil) veil.classList.add('gdb-open');
      updateScrollLock();
    }
    GDB.closeAllSheets = function () {
      ['gdb-receipt-sheet', 'gdb-detail-sheet'].forEach(function (id) { var el = $(id); if (el) el.classList.remove('gdb-open'); });
      var veil = $('gdb-sheet-veil');
      if (veil) veil.classList.remove('gdb-open');
      updateScrollLock();
    };

    function setGalDot(i) {
      var dots = document.querySelectorAll('#gdb-gal-dots button');
      Array.prototype.forEach.call(dots, function (d, j) { d.classList.toggle('gdb-active', j === i); });
    }
    GDB.galGo = function (i) {
      var track = $('gdb-gal-track');
      if (!track) return;
      var slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setGalDot(i);
    };
    var galObserver = null;
    function bindGallery() {
      var track = $('gdb-gal-track');
      if (!track) return;
      if (galObserver) galObserver.disconnect();
      var slides = Array.prototype.slice.call(track.children);
      galObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setGalDot(slides.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { galObserver.observe(s); });
    }

    GDB.openDetail = function (id) {
      var p = byId(id);
      if (!p) return;
      var gal = [p.img, p.imgHover].concat(p.extraImgs || []).filter(Boolean);
      var priceLine = p.preview ? (S.previewChip || 'Coming soon. Preview item, not on sale yet.')
                    : p.type === 'premium' ? (S.detailPremiumChip || 'Counts toward your Starting 4')
                                           : (S.detailBaseChip || 'Free pick after your Starting 4');
      $('gdb-detail-body').innerHTML =
        '<div class="gdb-gal-track" id="gdb-gal-track">' + gal.map(function (s) { return '<img src="' + s + '" alt="' + esc(p.title) + '">'; }).join('') + '</div>' +
        (gal.length > 1 ? '<div class="gdb-gal-dots" id="gdb-gal-dots">' + gal.map(function (_, i) {
          return '<button type="button" class="' + (i === 0 ? 'gdb-active' : '') + '" aria-label="Photo ' + (i + 1) + '" onclick="GDB.galGo(' + i + ')"></button>';
        }).join('') + '</div>' : '') +
        '<h4>' + esc(p.popupTitle || p.title) + '</h4>' +
        '<div class="gdb-pz-price-chip ' + (p.type === 'base' ? 'gdb-free-chip' : '') + '" style="margin-bottom:8px;">' + esc(priceLine) + '</div>' +
        '<div class="gdb-detail-desc">' + (p.desc || '') + '</div>' +
        '';
      var pFoot = $('gdb-detail-footer');
      if (pFoot) pFoot.innerHTML = '<div class="gdb-detail-cta">' + (p.available === false
        ? '<button type="button" class="gdb-detail-add" disabled>' + esc(S.soldOut || 'Sold Out') + '</button>'
        : '<button type="button" class="gdb-detail-add" onclick="GDB.add(\'' + p.id + '\'); GDB.closeAllSheets();">' + esc(S.addToBox || 'Add to Box') + '</button>') + '</div>';
      bindGallery();
      openSheet('gdb-detail-sheet');
    };

    GDB.openAddonDetail = function (id) {
      var a = addonById(id);
      if (!a) return;
      $('gdb-detail-body').innerHTML =
        '<div class="gdb-gal-track"><img src="' + a.img + '" alt="' + esc(a.title) + '"></div>' +
        '<h4>' + esc(a.title) + '</h4>' +
        '<div class="gdb-pz-price-chip" style="margin-bottom:8px;">' + money(a.price) + ' · ' + esc(S.addonChip || 'ships in the same cooler') + '</div>' +
        '<div class="gdb-detail-desc">' + (a.desc || '') + '</div>' +
        '';
      var aFoot = $('gdb-detail-footer');
      if (aFoot) aFoot.innerHTML = '<div class="gdb-detail-cta">' + (a.available === false
        ? '<button type="button" class="gdb-detail-add" disabled>' + esc(S.soldOut || 'Sold Out') + '</button>'
        : '<button type="button" class="gdb-detail-add" onclick="GDB.addonChange(\'' + a.id + '\', 1); GDB.closeAllSheets();">' + esc(S.addToOrder || 'Add to Order') + '</button>') + '</div>';
      openSheet('gdb-detail-sheet');
    };

    /* ---------- upsell modal ---------- */
    var upsellSnapshot = null;
    function restoreUpsellSnapshot() {
      if (upsellSnapshot) { state.addons = upsellSnapshot.slice(); upsellSnapshot = null; sync(); }
    }
    function renderUpsellModal() {
      var wrap = $('gdb-um-items');
      if (!wrap) return;
      wrap.innerHTML = ADDONS.filter(function (a) { return a.available !== false; }).map(function (a) {
        return '<button type="button" class="gdb-um-item' + (addonQty(a.id) ? ' gdb-added' : '') + '" onclick="GDB.umToggle(\'' + a.id + '\')">' +
          '<img class="gdb-umi-img" src="' + a.img + '" alt="">' +
          '<span class="gdb-umi-body"><span class="gdb-umi-name">' + esc(a.title) + '</span><br>' +
          '<span class="gdb-umi-price">' + money(a.price) + ' · ' + esc(S.addonChip || 'ships in the same cooler') + '</span></span>' +
          '<span class="gdb-umi-add">' + (addonQty(a.id) ? '✓' : esc(S.addLabel || 'ADD')) + '</span>' +
        '</button>';
      }).join('');
      var go = $('gdb-um-go');
      if (go) go.textContent = (S.ctaReady || 'Add Box to Cart') + ' · ' + money(boxTotal());
    }
    GDB.umToggle = function (id) {
      GDB.toggleAddon(id);
      renderUpsellModal();
    };

    /* ---------- checkout ---------- */
    function buildPayload() {
      var allProducts = state.cart.slice(0, BOX_SIZE).map(byId);
      var totalBoxPrice = PRICE_BOX;
      // Split the box price into per-pizza cents, never more than 1 cent apart:
      // floor each share, then hand the leftover pennies to the first items.
      var totalCents = Math.round(totalBoxPrice * 100);
      var baseCents = Math.floor(totalCents / BOX_SIZE);
      var leftoverCents = totalCents - baseCents * BOX_SIZE;

      var components = [];
      allProducts.forEach(function (p, index) {
        var price = (baseCents + (index < leftoverCents ? 1 : 0)) / 100;
        var existing = components.filter(function (c) { return c.id === p.variantId && c.price === price; })[0];
        if (existing) { existing.quantity++; } else { components.push({ id: p.variantId, quantity: 1, price: price }); }
      });

      var properties = {
        '_components': JSON.stringify(components),
        '_pack_size': BOX_SIZE,
        '_settings': JSON.stringify({ title: (config.bundleTitle || 'Gameday Box: ' + BOX_SIZE + '-Pizza Pack') }),
        '_bundle_id': Date.now().toString()
      };
      allProducts.forEach(function (p, index) {
        properties['Item ' + (index + 1)] = p.title === 'Meat & More' ? 'Meat and More' : p.title;
      });

      var payload = { items: [{ id: config.masterVariantId, quantity: 1, properties: properties }] };

      var addonTally = {};
      state.addons.forEach(function (id) { addonTally[id] = (addonTally[id] || 0) + 1; });
      Object.keys(addonTally).forEach(function (id) {
        var a = addonById(id);
        if (!a || a.available === false || !a.variantId) return;
        payload.items.push({ id: a.variantId, quantity: addonTally[id] });
      });

      if (config.trackingTag) payload.attributes = { 'Origin': config.trackingTag };
      return payload;
    }

    function openNativeDrawer() {
      var nativeDrawer = document.querySelector('cart-drawer');
      if (nativeDrawer) {
        if (typeof nativeDrawer.open === 'function') nativeDrawer.open();
        else if (typeof nativeDrawer.show === 'function') nativeDrawer.show();
        else {
          var headerCart = document.querySelector('[aria-controls="cart-drawer"], a[href="/cart"].header__icon--cart, #cart-icon-bubble');
          if (headerCart) headerCart.click(); else window.location.href = '/cart';
        }
      } else { window.location.href = '/cart'; }
    }

    function resetBuilder() {
      state.cart = []; state.addons = [];
      state.unlockedOnce = false; state.shipShown = false; state.postAdd = false;
      var step2 = $('gdb-step2');
      if (step2) step2.classList.remove('gdb-unlocked');
      renderCards();
      sync();
      var top = $('gdb-root');
      if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function submitBox() {
      if (hasPreviewInBox()) { toast(S.previewBlocked || 'Preview pies are display-only for now. Remove them to place an order.'); return; }
      if (!config.masterVariantId) {
        toast(S.notConfigured || 'Master bundle product is not configured in the Theme Editor.');
        return;
      }
      var buttons = ['gdb-sb-cta', 'gdb-desk-cta'].map($).filter(Boolean);
      buttons.forEach(function (b) { b.disabled = true; b.classList.add('gdb-is-loading'); });

      var gdbPayload = buildPayload();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(gdbPayload)
      }).then(function (res) {
        if (!res.ok) {
          return res.text().then(function (body) {
            console.error('[GDB] cart add rejected', res.status, body);
            console.error('[GDB] payload was', JSON.stringify(gdbPayload));
            throw new Error('add failed');
          });
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return fetch('/cart.js');
      }).then(function (res) { return res.json(); }).then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        state.postAdd = true;
        buttons.forEach(function (b) { b.classList.remove('gdb-is-loading'); });
        toast('✓ ' + (S.postAddNote || 'Box added to cart'));
        sync();
        setTimeout(openNativeDrawer, 100);
      }).catch(function () {
        buttons.forEach(function (b) { b.disabled = false; b.classList.remove('gdb-is-loading'); });
        toast(S.cartError || 'Something went wrong adding your box. Please try again.');
      });
    }

    function hasPreviewInBox() {
      return state.cart.some(function (id) { var p = byId(id); return p && p.preview; });
    }

    function onCheckout() {
      if (state.postAdd) { resetBuilder(); return; }
      if (hasPreviewInBox()) { toast(S.previewBlocked || 'Preview pies are display-only for now. Remove them to place an order.'); return; }
      var ready = state.cart.length === BOX_SIZE && premiumCount() >= REQUIRED_PREMIUM;
      if (!ready) {
        if (!isUnlocked()) { GDB.pulse('gdb-step1'); toast(S.pickSpecialtyFirst || 'Pick your Starting 4 specialty pies first.'); }
        else { GDB.pulse('gdb-step2'); toast(S.finishBox || 'Call your remaining free picks to finish the box.'); }
        return;
      }
      if (config.upsellEnabled !== false && state.addons.length === 0 && ADDONS.filter(function (a) { return a.available !== false; }).length > 0) {
        upsellSnapshot = state.addons.slice();
        renderUpsellModal();
        var veil = $('gdb-upsell-veil');
        if (veil) veil.classList.add('gdb-open');
        updateScrollLock();
      } else {
        submitBox();
      }
    }

    /* ---------- wiring ---------- */
    ['gdb-sb-cta', 'gdb-desk-cta'].forEach(function (id) { var b = $(id); if (b) b.addEventListener('click', onCheckout); });
    var sbView = $('gdb-sb-view');
    if (sbView) sbView.addEventListener('click', function () { openSheet('gdb-receipt-sheet'); });
    var sheetVeil = $('gdb-sheet-veil');
    if (sheetVeil) sheetVeil.addEventListener('click', GDB.closeAllSheets);
    var umGo = $('gdb-um-go');
    if (umGo) umGo.addEventListener('click', function () { upsellSnapshot = null; $('gdb-upsell-veil').classList.remove('gdb-open'); updateScrollLock(); submitBox(); });
    var umSkip = $('gdb-um-skip');
    if (umSkip) umSkip.addEventListener('click', function () { restoreUpsellSnapshot(); $('gdb-upsell-veil').classList.remove('gdb-open'); updateScrollLock(); submitBox(); });
    var upsellVeil = $('gdb-upsell-veil');
    if (upsellVeil) upsellVeil.addEventListener('click', function (e) { if (e.target === upsellVeil) { restoreUpsellSnapshot(); upsellVeil.classList.remove('gdb-open'); updateScrollLock(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') GDB.closeAllSheets(); });

    renderCards();
    sync();
  });
})();
